import $ from 'jquery';
import {
	PROVINCE_BILL_INPUT,
	PROVINCE_SHIP_INPUT,
	STATE_BILL_SELECT,
	STATE_SHIP_SELECT,
	US_STATES,
	WORLD_COUNTRIES,
} from './constants';
import {
	debug,
	handleFinishedOrderError,
	loadScript,
	lowerCaseAllWordsExceptFirstLetters,
	skipUpsell,
	getQueryParamValue,
	debounce,
} from './utils';
import {
	konnektive_get_partial,
	doUpdateLead,
	doAddUpsell,
} from './api';
import {
	getConfig,
	getCookieValue,
	getSessionStorage,
	setSessionStorage
} from './config';
import { normalizePageName } from './routing';
import { useCheckoutGateway } from './checkoutGateway';

let createProspectTrigerred = false;

export function doRTPostback(pbSettings) {
	if (getConfig().rtPostbacks && pbSettings.clickid) {
		if (pbSettings.domain == 'trk.cloud-bytes.net') pbSettings.label = 'CB';
		if (pbSettings.domain == 'trk.bit-bytes.net') pbSettings.label = 'BB';
		if (location.protocol) {
			var locProt = location.protocol;
		} else {
			var locProt = 'http:';
		}
		var locProt = 'https:';
		let RTURL = `${locProt}//${pbSettings.domain}/postback?clickid=${pbSettings.clickid}`;

		if (pbSettings.type) RTURL += `&type=${pbSettings.type}`;
		if (pbSettings.sum) RTURL += `&sum=${pbSettings.sum}`;
		if (pbSettings.email) RTURL += `&sub1=${pbSettings.email}`;
		if (pbSettings.label) RTURL += `&sub3=${pbSettings.label}`;
		if (pbSettings.orderid) RTURL += `&sub2=${pbSettings.orderid}`;

		const settings = {
			url: RTURL,
			method: 'GET',
			crossDomain: true,
			timeout: 0,
		};

		$.ajax(settings).done((response) => {
			debug('RT response ' + response.message);
		}).fail(() => {
			debug('RT fallback state. Iframe will be added.');
			$('body').append(`<iframe id="rtfallback" src="${RTURL}" style="border: 0px; height: 0px; width: 0px; position: absolute;"></iframe>`);

		});
	} else {
		debug('RT won\'t be fired.');
	}
}

export function roundToTwo(num) {
	return +(`${Math.round(`${num}e+2`)}e-2`);
}

export function openPopUpUrl(e, t, a) {
	return window.open(e, '', `height=${t}, width=${a}, scrollbars=yes, resizable=yes`);
}

// Raw filename, extension included. Kept byte-for-byte because it is re-exposed
// as a global and funnel-side code calls it; changing what it returns would
// break sites silently. Prefer getCurrentPageName() for anything new.
export function getCurentFileName() {
	const pagePathName = window.location.pathname;
	return pagePathName.substring(pagePathName.lastIndexOf('/') + 1);
}

// Host-agnostic page identity: 'checkout' whether the host serves
// /checkout.html or /checkout. This is what the engine routes on.
export function getCurrentPageName() {
	return normalizePageName(window.location.pathname);
}

export function isIndex() {
	const fname = getCurrentPageName();
	if (!fname || fname.indexOf('index') != -1) return true;
	return false;
}

// Rounding and price formatting
export function round(value, decimals) {
	return Number(value).toFixed(decimals);
}

export function initKount() {
	const checkoutForm = document.forms.payment_form;
	let kountMID = 0;
	if (checkoutForm) {

	if (getConfig().provider == "konnektive") {
		kountMID = getConfig().kountMerchantIDKonnektive;
	}

		loadScript(`https://ssl.kaptcha.com/collect/sdk?m=${kountMID}`, () => {
			const client = new ka.ClientSDK();
			client.setupCallback({
				'collect-begin': function(params) {
					debug('Kount Params', params);
					const checkoutForm = document.forms.payment_form;
					const input = document.createElement('input');
					input.type = 'hidden';
					input.name = 'sessionId';
					input.value = params.MercSessId;
					checkoutForm.appendChild(input);
				},
			});
			client.autoLoadEvents();
		});
	}
}

export function addUpsell() {
	if (getConfig().provider == "konnektive") {
		doAddUpsell();
	}
}

// Copy the shipping values into the billing fields.
//
// render() has already hydrated the #cShip* inputs — from the sessionStorage
// handoff, from the query string, or both — so read the field and fall back to
// the query only if it is not there. Reading the query directly would return
// nothing once PII stops travelling in the URL.
export function shipValue(key) {
	const field = $('#' + key);
	if (field.length && field.val()) return field.val();
	return getQueryParamValue(key) || '';
}

export function appendShippingInfo() {
	$('#msclkidInput').html(getCookieValue('msclkid'))
	$('#cBillFName').val(shipValue('cShipFName'));
	$('#cBillLName').val(shipValue('cShipLName'));
	$('#cBillAddress1').val(shipValue('cShipAddress1'));
	$('#cBillZip').val(shipValue('cShipZip'));
	$('#cBillCity').val(shipValue('cShipCity'));
	$('#cBillState').val(shipValue('cShipState'));
}

export function setDefaultBonusActions() {
	const orderID = sessionStorage.getItem('order_id');
	if (!orderID && !getQueryParamValue('test')) {
		handleFinishedOrderError();
	}
	$('html').removeClass('placeholder');
	$('.btn-yes, .btn-success, .btn-noThanks').unbind('click');
	$('.btn-yes, .btn-success').click(() => {
		$('.overlay, .processing').show();
		const debouncedAddUpsell = debounce(() => addUpsell()); debug('Debouncing...');
		debouncedAddUpsell();
		//addUpsell();
	});
	$('.btn-noThanks').click(() => {
		skipUpsell();
	});
	if ($('img[data-rel="mainBonusImage"]').length) {
		if (getSessionStorage('imagesList')) {
			var storageImageData = JSON.parse(getSessionStorage('imagesList'));

			if (getConfig().provider == "konnektive") {
				var bonusImageID = getConfig().upsells[getConfig().upsellIndex].pid_konnektive;
			}

			$.each(storageImageData, (i, entry) => {
				if (parseInt(entry[0].pid) == parseInt(bonusImageID)) {
					$('img[data-rel="mainBonusImage"]').attr('src', entry[0].url);
				}
			});
		}
	}
}

/* ------------------------------ START OF PLATFORM UTILS ------------------- */

export function combineExpDate() {
	const cardMonth = $('select[id="ccMonth"]').val();
	const cardYear = $('select[name="ccYear"]').val();
	if (cardMonth && cardYear) {
		const expDate = cardMonth + cardYear.substr(2);
		$('input[name="ccExp"]').val(expDate);
		$('#payment_form').validate().element('input[name="ccExp"]');
	}
}

export function getBillingModels(modelID) {
	var bilModStr = '';
	$.each(getConfig().billingModels, function(i, order_id) {
		bilModStr += '<option ';
		if (order_id.id == modelID) {
			bilModStr += 'disabled ';
		}
		bilModStr += 'value="' + order_id.id + '">' + order_id.name + '</option>';
	})
	return bilModStr;
}

export function getKNKBillingModels(modelID) {
	var bilModStr = '';
	bilModStr += '<option value="30">Each 30 days</option>';
	bilModStr += '<option value="60">Each 60 days</option>';
	bilModStr += '<option value="90">Each 90 days</option>';
	return bilModStr;
}

export function errorHandling() {
	$('.processing').hide();
	$('.order_error').show();
}

export function getOrdersList() {
	const storageData = getSessionStorage('ordersList');
	let ordersList = [];
	if (storageData.length > 0) {
		return JSON.parse(storageData);
	}
	return false;
}

export function initImagesData() {
	if (isIndex()) { // cleanup procedure for homepages
		sessionStorage.removeItem('imagesList');
	}

	var storageImageData = getSessionStorage('imagesList');
	if (!storageImageData) {
		var storageImageData = [];
		$.each(getConfig().products, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid,
				url: '',
			}]);
		});
		$.each(getConfig().upsells, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid,
				url: '',
			}]);
		});
		$.each(getConfig().gifts, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid,
				url: '',
			}]);
		});
		storageImageData.push([{
			pid: getConfig().shippingProtectionID,
			url: '',
		}]);
		setSessionStorage('imagesList', JSON.stringify(storageImageData));
	} else {
		storageImageData = JSON.parse(storageImageData);
	}

	// lets fill with urls
	$.each(storageImageData, (i, product) => {
		if (!product[0].url) { // no URL detected - will make some API calls
			if (!getConfig().domain) { // Sticky-only API; empty by default
				return;
			}
			const settings = {
				url: `https://${getConfig().domain}/${getConfig().api2Version}/products/${product[0].pid}/images`,
				method: 'GET',
				timeout: 0,
				headers: getConfig().authHeaders,
			};
			$.ajax(settings).done((response) => {
				if (response.data) { // check if there's an image
					storageImageData[i][0].url = response.data[0].path;
					setSessionStorage('imagesList', JSON.stringify(storageImageData));
				}
			});
		} else { // URL is here. skipping...

		}
	});

	// lets get download links if available
	$.each(storageImageData, (i, prod) => {
		if (!prod[0].download) { // no URL detected - will make some API calls
			if (!getConfig().domain) { // Sticky-only API; empty by default
				return;
			}
			const settings = {
				url: `https://${getConfig().domain}/${getConfig().api2Version}/products/${prod[0].pid}`,
				method: 'GET',
				timeout: 0,
				headers: getConfig().authHeaders,
			};
			$.ajax(settings).done((response) => {
				if (response.status == 'SUCCESS') {
					if (response.data && response.data.custom_fields[0]) {
						var digital_download = '-';
						$.each(response.data.custom_fields, (k, i) => {
							if (i.id == 29) {
								digital_download = i.values[0].value;
							} else {}
						})

						storageImageData[i][0].download = digital_download;
						setSessionStorage('imagesList', JSON.stringify(storageImageData));
					} else {
						storageImageData[i][0].download = '-';
						setSessionStorage('imagesList', JSON.stringify(storageImageData));
					}
				}
			});
		} else { // URL is here. skipping...

		}
	});
}

export function clearCookies(cookies_to_clear) {
	$.each(cookies_to_clear, (k, v) => {
		document.cookie = `${v}=` + '' + ';path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
	});
}

// Cart-abandonment recovery: a ?chash= link carries an opaque customer hash, and
// the partial lead behind it is fetched server-side to prefill the form.
//
// This MUST be called from init(), not at module scope. It reads
// getConfig().provider, and config now loads asynchronously — at module-eval
// time getConfig() is still {}, so the provider check fails and the lookup never
// fires. It used to appear to work only because config was persisted in
// localStorage: recovery traffic is by definition a returning visitor, so the
// previous page's copy was there to read. Removing that persistence (1.2.0)
// exposed the latent ordering bug and silently killed ?chash= prefill.
export function initCartAbandonment() {
	if ($('form[data-CA="true"]').length === 0) return;

	const customerHash = getQueryParamValue('chash');
	if (!customerHash) return;

	// G-8: skipped before the overlay goes up, so the shopper sees an empty,
	// working checkout. Tomorrow's signed links (G-6) bring it back via /recover.
	if (useCheckoutGateway()) {
		debug('Cart pre-fill skipped (checkout gateway)');
		return;
	}

	if (getConfig().provider == "konnektive") {
		$('.overlay, .processing').show();
		konnektive_get_partial(customerHash);
	}
}

export function cleanUpUserInput() {
	$('#payment_form input, #shipping_form input').each(function() {
		$(this).val($(this).val().replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi, '')); // remove emojis
		$(this).val($(this).val().replace(/  +/g, ' ')); // remove extra spaces
	});
}
